    document.querySelectorAll('[data-confirm]').forEach((confirmButton) =>
    {
	confirmButton.onclick = function (event) {
	    if (!confirm(confirmButton.dataset.confirm)) {
		event.preventDefault();
	    }
	};
    });